import React from 'react'
import PropTypes from 'prop-types'
import { Spin } from 'antd'
import { useQuery } from '@apollo/client'
import { pathOr } from 'ramda'
import styled from 'styled-components'

import MEMBER_STATUS from 'apollo/queries/MEMBER_STATUS'

const MemberStatus = ({ memberId }) => {
  const { loading, data } = useQuery(MEMBER_STATUS, {
    variables: { id: memberId },
    skip: !memberId
  })

  if (loading) return <Spin />
  const member = pathOr({}, ['member'], data)
  const { register_status, organization_live } = member

  return (
    <Wrapper>
      The member is{' '}
      <Registered status={register_status}>{register_status}</Registered>. The
      client is{' '}
      <Live status={organization_live}>
        {organization_live ? 'live' : 'NOT live'}
      </Live>
      .
    </Wrapper>
  )
}

const Wrapper = styled.p`
  margin: -20px 0 16px 0;
`

const Registered = styled.span`
  color: ${props => (props.status === 'registered' ? 'green' : 'red')};
`

const Live = styled.span`
  color: ${props => (props.status ? 'green' : 'red')};
`

MemberStatus.propTypes = {
  memberId: PropTypes.string.isRequired
}

export default MemberStatus
